import React, { useState } from 'react';
import CourseCard from './CourseCard';
import Videos from '../../../constant/Videos';
const courses = [
  {
    title: 'Introduction to Accounting',
    description: 'Workason Accounting & Finance Professional Intro.',
    price: 49.99,
    instructor: 'John Doe',
    videoUrl: Videos.CardOneVi,
    content: [
      'Introduction to Accounting',
      'Double-Entry Bookkeeping',
      'Accounts Payable & Receivable',
      'Bank Reconciliation',
      'Financial Statements Basics',
      'Project: Set Up a Client Ledger',
    ],
  },
  {
    title: 'Conclusion: Your Accounting Career',
    description: 'Wrapping up our accounting and finance professional course.',
    price: 59.99,
    instructor: 'Jane Smith',
    videoUrl: Videos.CardOneVi,
    content: [
      'Review of Key Accounting Concepts',
      'Tax Compliance Overview',
      'Payroll Processing Summary',
      'Financial Reporting Best Practices',
      'Building Long-Term Client Relationships',
      'Next Steps as an Accounting Professional',
    ],
  },
  {
    title: 'ESSENTIAL TOOLS NEEDED AS AN ACCOUNTANT',
    description: 'Here is the list of essential tools needed to become a professional accountant.',
    price: 59.99,
    instructor: "John",
    videoUrl: Videos.CardOneVi,
    content: [
      'QuickBooks & Xero',
      'Excel for Accountants',
      'Sage Payroll',
      'HMRC Online Tools',
      'Cloud Accounting Platforms',
      'Document Management Software',
    ],
  },
  {
    title: 'HOW TO BUILD THE PERFECT PORTFOLIO AS AN ACCOUNTANT',
    description: 'Step-by-step guide to building a standout accounting portfolio.',
    price: 59.99,
    instructor: 'Jane Smith',
    videoUrl: Videos.CardOneVi,
    content: [
      'Choosing Your Accounting Niche',
      'Showcasing Client Results',
      'Writing a Compelling SmartCV',
      'Collecting Testimonials',
      'Presenting Financial Case Studies',
      'Getting SkillStamped on Workason Accounting',
    ],
  },
  {
    title: 'Advanced TypeScript',
    description: 'Master TypeScript for large-scale applications.',
    price: 59.99,
    instructor: 'Jane Smith',
    videoUrl: Videos.CardOneVi,
    content: [
      'TypeScript Basics',
      'Interfaces & Types',
      'Generics in TypeScript',
      'Advanced Types',
      'TypeScript with React',
      'Building a Large-Scale Project',
    ],
  },
  {
    title: 'Advanced TypeScript',
    description: 'Master TypeScript for large-scale applications.',
    price: 59.99,
    instructor: 'Jane Smith',
    videoUrl: Videos.CardOneVi,
    content: [
      'TypeScript Basics',
      'Interfaces & Types',
      'Generics in TypeScript',
      'Advanced Types',
      'TypeScript with React',
      'Building a Large-Scale Project',
    ],
  },
  {
    title: 'Advanced TypeScript',
    description: 'Master TypeScript for large-scale applications.',
    price: 59.99,
    instructor: 'Jane Smith',
    videoUrl: Videos.CardOneVi,
    content: [
      'TypeScript Basics',
      'Interfaces & Types',
      'Generics in TypeScript',
      'Advanced Types',
      'TypeScript with React',
      'Building a Large-Scale Project',
    ],
  },
  {
    title: 'Advanced TypeScript',
    description: 'Master TypeScript for large-scale applications.',
    price: 59.99,
    instructor: 'Jane Smith',
    videoUrl: Videos.CardOneVi,
    content: [
      'TypeScript Basics',
      'Interfaces & Types',
      'Generics in TypeScript',
      'Advanced Types',
      'TypeScript with React',
      'Building a Large-Scale Project',
    ],
  },
  {
    title: 'Advanced TypeScript',
    description: 'Master TypeScript for large-scale applications.',
    price: 59.99,
    instructor: 'Jane Smith',
    videoUrl: Videos.CardOneVi,
    content: [
      'TypeScript Basics',
      'Interfaces & Types',
      'Generics in TypeScript',
      'Advanced Types',
      'TypeScript with React',
      'Building a Large-Scale Project',
    ],
  },
];
const COURSES_PER_PAGE = 8; // Number of courses per page

const CourseList = () => {
  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const totalCourses = courses.length;
  const totalPages = Math.ceil(totalCourses / COURSES_PER_PAGE); // Calculate total pages

  // Calculate start and end index for slicing the courses array
  const startIndex = (currentPage - 1) * COURSES_PER_PAGE;
  const currentCourses = courses.slice(startIndex, startIndex + COURSES_PER_PAGE);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="container mx-auto p-6 mt-[8rem]">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {currentCourses.map((course, index) => (
          <CourseCard
            key={index}
            title={course.title}
            description={course.description}
            price={course.price}
            instructor={course.instructor}
            videoUrl={course.videoUrl}
            content={course.content}
          />
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center mt-6 space-x-4">
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded disabled:opacity-50"
        >
          Previous
        </button>
        <span className="text-lg font-medium">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CourseList;
